// Vendor imports
const { connect } = require('react-redux')
// Common client-v2 imports
const deferDispatch = require('client-v2/common/state/dispatch')
// Entry imports
const authModalActions = require('./actions')

function mapStateToProps(state) {
  return {
    isSULandingPage: state.authModal.isSULandingPage
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onLoginClick: dispatchAction(authModalActions.showLogin),
    onSignupClick: dispatchAction(authModalActions.showSignup),
    onSULoginClick: dispatchAction(authModalActions.showSULogin)
  }
}

const ConnectAuthModalActions = connect(mapStateToProps, mapDispatchToProps)

module.exports = Object.assign(ConnectAuthModalActions, {
  mapStateToProps,
  mapDispatchToProps
})
